/* Custom header — sticky scroll state + mobile drawer toggle */
(function () {
  if (customElements.get('custom-header')) return;

  class CustomHeader extends HTMLElement {
    constructor() {
      super();
      this._onScroll = this._onScroll.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
    }

    connectedCallback() {
      this.toggleBtn = this.querySelector('[data-menu-toggle]');
      this.drawer = this.querySelector('[data-drawer]');
      this.closeEls = this.querySelectorAll('[data-drawer-close]');

      if (this.toggleBtn && this.drawer) {
        this.toggleBtn.addEventListener('click', () => this.openDrawer());
        this.closeEls.forEach((el) => el.addEventListener('click', () => this.closeDrawer()));
      }

      if (this.dataset.sticky === 'true') {
        this._applyStickyToParent();
        window.addEventListener('scroll', this._onScroll, { passive: true });
        this._onScroll();
      }

      document.addEventListener('keydown', this._onKeydown);
    }

    _applyStickyToParent() {
      // position: sticky on the inner element sticks within its parent's height,
      // which is only as tall as the header itself. We need the .shopify-section
      // wrapper (a direct child of <body>) to be the sticky element so it sticks
      // within the full page height. Dawn already ships .shopify-section-header-sticky
      // with the right CSS, so we reuse it.
      const sectionWrapper = this.closest('.shopify-section');
      if (sectionWrapper) {
        sectionWrapper.classList.add('shopify-section-header-sticky');
        sectionWrapper.style.zIndex = '50';
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      document.removeEventListener('keydown', this._onKeydown);
    }

    _onScroll() {
      if (window.scrollY > 8) {
        this.classList.add('is-scrolled');
      } else {
        this.classList.remove('is-scrolled');
      }
    }

    _onKeydown(e) {
      if (e.key === 'Escape' && this.drawer && this.drawer.classList.contains('is-open')) {
        this.closeDrawer();
      }
    }

    openDrawer() {
      if (!this.drawer) return;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('custom-header-drawer-open');

      // Focus the close button so Esc/Tab work intuitively
      const closeBtn = this.drawer.querySelector('.custom-header__drawer-close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    closeDrawer() {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.toggleBtn) {
        this.toggleBtn.setAttribute('aria-expanded', 'false');
        this.toggleBtn.focus({ preventScroll: true });
      }
      document.body.classList.remove('custom-header-drawer-open');
    }
  }

  customElements.define('custom-header', CustomHeader);
})();
